<template>
  <div class="sidebar-container">
    <div class="header">
      Simply.Studio
    </div>
    <div class="view-selector">
      <div class="designer" 
        :class="{active: view == 'designer'}" 
        @click="designerTabActive()">
        Designer
      </div>
      <div class="rooms" 
        :class="{active:view == 'rooms' }" 
        @click="showPopup()">
        <span :class="{pulse: animate}">Layouts</span>
      </div>
    </div>
    <div class="sidebar-content">
      <div v-show="view == 'designer'" class="designer-container">
        <div class="room-selector section">
          <div class="section-header" @click="roomSelectionExpanded = !roomSelectionExpanded">
            <div class="section-name">Select Room</div>
            <div class="expand-icon" :class="{'expanded': roomSelectionExpanded }"><i class="fa fa-chevron-up"/></div>
          </div>
          <div v-show="roomSelectionExpanded" class="section-content">
            <div class="room-category-selector category-selector">
              <div class="stock" 
                :class="{active:roomSelectionCategory == 'stock'}" 
                @click="roomSelectionCategory = 'stock'">
                Stock
              </div>
              <div class="user" 
                :class="{active:roomSelectionCategory == 'custom'}" 
                @click="showPopup()">
                Custom
              </div>
            </div>
            <div class="room-options">
              <div v-for="r in roomOptions" class="room-option" @click="$emit('selected-room', r)" :key="r.name">
                <img :src="r.url"/>
                <div v-if="roomSelectionCategory == 'custom'" class="edit-icon" @click="editCustomRoom = r">
                  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M17 3a2.828 2.828 0 1 1 4 4L7.5 20.5 2 22l1.5-5.5L17 3z"></path></svg>
                </div>
              </div>
              <div v-if="roomOptions.length < 1" class="no-rooms">No rooms found.</div>
            </div>
          </div>
        </div>

        <div class="product-selector section">
          <div class="section-header" @click="productSelectionExpanded = !productSelectionExpanded">
            <div class="section-name">Select Product</div>
            <div class="expand-icon" :class="{'expanded': productSelectionExpanded }"><i class="fa fa-chevron-up"/></div>
          </div>
          <div v-show="productSelectionExpanded" class="section-content">
            <div class="product-category-selector category-selector">
              <div class="singles" 
                :class="{active:productSelectionCategory == 'singles'}" 
                @click="productSelectionCategory = 'singles'">
                Singles
              </div>
              <div class="arrangements" 
                :class="{active:productSelectionCategory == 'arrangements'}" 
                @click="productSelectionCategory = 'arrangements'">
                Arrangements
              </div>
            </div>
            <div v-if="productSelectionCategory == 'singles'" class="product-options">
              <div class="paper" 
                draggable="true" 
                @dragstart="productDragStart($event, 'paper')"
                @click="$emit('add-product', 'paper')">
                paper
              </div>
              <div class="canvas" 
                draggable="true" 
                @dragstart="productDragStart($event, 'canvas')"
                @click="$emit('add-product', 'canvas')">
                canvas
              </div>
              <div class="metal" 
                draggable="true" 
                @dragstart="productDragStart($event, 'metal')"
                @click="$emit('add-product', 'metal')">
                metal
              </div>
              <div class="wood" 
                draggable="true" 
                @dragstart="productDragStart($event, 'wood')"
                @click="$emit('add-product', 'wood')">
                wood
              </div>
            </div>
            <div v-else class="product-options">
              <div v-for="a in arrangements" class="arrangement"
                :style="{ backgroundImage: 'url(' + a.thumbnail + ')' }"
                :key="a.name"
                draggable="true" 
                @dragstart="arrangementDragStart($event, a)"
                @click="addArrangement(a.products)"
                @mouseover="$emit('preview-arrangement', JSON.stringify(a.products))"
                @mouseout="$emit('preview-arrangement', null)">
              </div>
            </div>
          </div>
        </div>

        <div class="photo-selector section">
          <div class="section-header">
            <div class="section-name">Select Photos</div>
            <div class="favourites" @click="onlyFavourites = !onlyFavourites">
              <i v-if="onlyFavourites" class="fa fa-heart red"></i>
              <i v-else class="far fa-heart"></i>
            </div>
          </div>
          <div v-if="loading">
            <img
              src="../../../assets/spinner.svg"
              alt="loading"
            >
          </div>
          <div class="section-content">
            <div class="photos">
              <div v-for="p in photoOptions" class="photo" draggable="true" @dragstart="photoDragStart($event, p)" :key="p.name">
                <img :src="p.url"/>
              </div>
            </div>
          </div>
        </div>

      </div>

    </div>

  </div>
</template>

<script>
import arrangements from '@/data/arrangements.js'

export default {
  name: 'Sidebar',
  props: ['saveComplete', 'suggestions'],
  components: {
  },
  data() {
    return {
      view: 'designer',
      roomSelectionExpanded: true,
      roomSelectionCategory: 'stock',
      stockRooms: [
        {
          name: 'livingroom-1',
          url: 'https://storage.googleapis.com/simply-studio-pub-01/stock/livingroom-1.jpg', 
        },
        {
          name: 'livingroom-2',
          url: 'https://storage.googleapis.com/simply-studio-pub-01/stock/livingroom-2.jpg', 
        },
        {
          name: 'hallway',
          url: 'https://storage.googleapis.com/simply-studio-pub-01/stock/hallway.jpg', 
        },
        {
          name: 'livingroom-3',
          url: 'https://storage.googleapis.com/simply-studio-pub-01/stock/livingroom-3.jpg'
        },
        {
          name: 'bedroom',
          url: 'https://storage.googleapis.com/simply-studio-pub-01/stock/bedroom.jpg'
        },
        {
          name: 'kitchen',
          url: 'https://storage.googleapis.com/simply-studio-pub-01/stock/kitchen.jpg'
        },
      ],
      customRooms: [], 
      
      arrangements: arrangements,

      productSelectionExpanded: true,
      photoSelectionExpanded: true,
      onlyFavourites: false,
      photos: [
        {
          name: 'demo-01',
          url: 'https://storage.googleapis.com/simply-studio-pub-01/demo/demo-01.jpeg',
          favourite: true,
        },
        {
          name: 'demo-02',
          url: 'https://storage.googleapis.com/simply-studio-pub-01/demo/demo-02.jpeg',
          favourite: false,
        },
        {
          name: 'demo-03',
          url: 'https://storage.googleapis.com/simply-studio-pub-01/demo/demo-03.jpeg',
          favourite: false,
        },
        {
          name: 'demo-04',
          url: 'https://storage.googleapis.com/simply-studio-pub-01/demo/demo-04.jpeg',
          favourite: true,
        },
        {
          name: 'demo-05',
          url: 'https://storage.googleapis.com/simply-studio-pub-01/demo/demo-05.jpeg',
          favourite: true,
        },
      ],

      productSelectionCategory: 'singles',

      animate: false,
      loading: false,
      err: null,
    }
  },
  mounted() {
    this.$emit('selected-room', this.stockRooms[0])
    // this.loadAccessUrlsAndFavourites() // TODO: example photos
  },
  methods: {
    roomsTabActive() {
      this.view = 'rooms'
      this.$emit('designer-disabled', true)
    },
    designerTabActive() {
      this.view = 'designer'
      this.$emit('designer-disabled', false)
    },
    photoDragStart(e, p) {
      e.dataTransfer.setData("imgurl", JSON.stringify(p))
    },
    productDragStart(e, type) {
      e.dataTransfer.setData("product-type", type)
    },
    arrangementDragStart(e, arrangement) {
      e.dataTransfer.setData("arrangement", JSON.stringify(arrangement))
    },
    addArrangement(products) {
      this.$emit('preview-arrangement', null)
      this.$emit('add-arrangement', JSON.stringify(products))
    },
    loadLayout(s) {
      let room = this.stockRooms.find(r => r.name == s.room)
      if(!room) {
        room = this.customRooms.find(r => r.name == s.room)
      }
      if(!room) {
        throw("unknown room, couldn't find room for suggestion " + s)
      }
      this.$emit('load-room', Object.assign({}, s, { room: room }))
    },
    showPopup() {
      this.$emit('show-popup')
    }
    // async loadAccessUrlsAndFavourites() {
    //   this.loading = true

    //   // TODO: move this to store?!
    //   var promises = [];
    //   promises.push(accessURLService.getGalleryAccessURLs(this.user, this.project, this.secret))
    //   promises.push(projectService.getFavourites(this.user, this.project)) 
    //   Promise.all(promises)
    //     .then((res) => {
    //       let urls = res[0]
    //       let favourites = res[1]
          
    //       this.photos = urls.map(u => { 
    //         return Object.assign(u, { favourite: favourites.includes(u.name) })
    //       }).sort((a, b) => a.name > b.name ? 1 : -1)
    //       this.loading = false
    //     }, (err) => {
    //       this.err = err
    //       this.loading = false
    //     });
    // },
  },
  computed: {
    roomOptions() {
      if(this.roomSelectionCategory == 'custom')
        return this.customRooms
      return this.stockRooms
    },
    photoOptions() {
      if(this.onlyFavourites)
        return this.photos.filter(p => p.favourite)
      return this.photos
    },
  },
  watch: {
    saveComplete(newValue) {
      if(newValue) {
        this.animate = true
        setTimeout(() => {
          this.animate = false
        },1000)
      }
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@/assets/shared.scss';

.sidebar-container {
  height: 100%;
}
.header {
  font-size: 20px;
  font-weight: 500;
  padding: 20px 0px;
  position: relative;
  cursor: pointer;

  .back-icon {
    position: absolute;
    top: 20px;
    left: 20px;
    color: $secondaryText;
  }
}

.sidebar-content {
  height: calc(100vh - 115px);
  overflow-y: scroll;
}

.designer-container, .rooms-container {
  padding: 20px;
  padding-bottom: 0px;
  box-sizing: border-box;
  display:flex;
  flex-direction:column;

  .photo-selector {
    flex: 1;
  }
}

.section {
  background-color: white;
  margin-bottom: 20px;
  box-sizing: border-box;
  border-radius: $border-radius;
  // box-shadow: 2px 2px 10px rgba(grayscale($primary), 0.5);
  @include shadow;

  &:hover {
    .section-header .upload-photo {
      opacity: 1;
    }
  }
}
.section-header {
  padding: 10px 15px;
  cursor: pointer;
  position: relative;
  
  .section-name {
    display: inline-block;
  }

  .upload-photo {
    position: absolute;
    left: 10px;
    top: 5px;
    color: $secondaryText;
    padding: 5px;

    &:hover {
      color: $primary;
    }
    opacity: 0;
    transition: 0.1s opacity;
  }
}
.section-content {
  padding: 10px;
  padding-top: 0px;
}
.view-selector {  
  padding: 5px;
  display: flex;
  margin-bottom: 5px;

  div {
    flex: 1;
    padding: 5px 10px;
    cursor: pointer;
    color: $secondaryText;
    border-bottom: 1px solid $secondaryText;
  }
  .active {
    color: $primaryText;
    border-bottom: 4px solid $primary;
    font-weight: 500;
  }
}
.category-selector {  
  padding: 5px;
  display: flex;
  margin-bottom: 5px;
  // border-radius: $border-radius;

  div {
    flex: 1;
    padding: 8px 10px;
    cursor: pointer;
    color: $secondaryText;
    border-radius: 18px;
    border: 1px solid $secondaryText;
    box-sizing: border-box;
    transition: 0.2s all;

    &:hover {
      border: 1px solid $primary;
      color: $primary;
    }
  }

  div:first-child {
    margin-right: 5px;
  }
  div:last-child {
    margin-left: 5px;
  }

  .active {
    background-color: $primary;
    color: white !important;
    border: 1px solid $primary;
    @include shadow;
  }
}
.expand-icon {
  display: block;
  float: right;
  transition: 0.5s all;
  color: $secondaryText;

  &.expanded {
    transform: rotate(-180deg);
  }
}

.room-options {
  display: flex;
  flex-wrap: nowrap;
  overflow-x: auto;

  .room-option {
    height: 100px;
    flex: 0 0 auto;
    cursor: pointer;
    margin: 0px 5px;
    position: relative;

    img {
      max-height: 100%;
      max-width: 100%;
    }

    .edit-icon {
      position: absolute;
      top: 5px;
      right: 5px;
      color: $primary;
      filter: drop-shadow(0px 0px 1px rgba(255, 255, 255, 0.7));
      transition: transform 0.2s;

      &:hover {
        transform: scale(1.2);
      }
    }
  }

  .no-rooms {
    flex: 1;
    padding: 20px 0px;
    text-align: center;
    color: $secondaryText;
    font-weight: 500;
  }
}

.product-options {
  display: flex;
  overflow-x: scroll;
  padding: 5px;

  div {
    min-width: 70px;
    height: 70px;
    line-height: 70px;
    color: $primaryText;
    margin: 0px 5px;
    cursor: pointer;
  
    border-radius: 3px;
    transition: 0.1s all;
    display: inline-block;
    margin: 3px;
    box-shadow: 2px 2px 4px rgba(0, 0, 0, 0.3);
    background-size: cover;
    background-position: center;
    cursor: pointer;

    &:hover {
      transform: scale(1.1);
    }
  }

  .canvas {
    background-image: url(../../../assets/canvas.jpg);
  }
  .wood {
    background-image: url(../../../assets/wood.jpg);
  }
  .metal {
    background-image: url(../../../assets/metal.jpg);
  }
  .paper {
    background-color: rgb(235, 234, 230);
  }
}

.arrangement {
  border: 1px solid red;
  background-size: contain;
  background-position: center;
}


.favourites {
  position: absolute;
  top: 10px;
  right: 10px;
}

.photo-selector {
  display: flex;
  flex-direction: column;
  min-height: 0px;

  .section-content {
    flex: 1 1 auto;
    overflow-y: auto;
  }
}
.photos {
  column-count: 2;
  
  .photo {
    width: 100%;

    img {
      max-width: 100%;
      max-height: 100%;
    }
  }
}

.presenter {
  margin-bottom: 20px;
  cursor: pointer;
  opacity: 0.3;
  transition: 0.1s opacity;

  &:hover {
    opacity: 1;
  }

  a {
    color: inherit;
  }
}

.saved-room {
  background-position: center;
  background-size: cover;
  margin-bottom: 10px;
  border-radius: $border-radius;
  overflow: hidden;

  .room-header {
    border-bottom: 4px solid $primary;
    text-align: left;
    padding: 5px 10px;
    background-color: rgba(255, 255, 255, 0.75);
  }

  .layout {
    background-color: rgba(255, 255, 255, 0.6);
    transition: 0.1s all;
    cursor: pointer;
    padding: 10px 0px;
    position: relative;

    &:hover {
      background-color: rgba(255, 255, 255, 0.8);
    }
  }
}

.no-saved-rooms {
  color: $secondaryText;
  padding: 20px 0px;
}

.delete-icon {
  position: absolute;
  right: 10px;
  top: 10px;
  color: $red;
  opacity: 0.5;
  transition: opacity 0.1s;
  &:hover {
    opacity: 1;
  }
  .confirm {
    position: relative;
    top: -3px;
    padding: 5px 10px;
    border-radius: $border-radius;
    background-color: $red;
    color: white;
    cursor: pointer;
    transition: 0.2s all;
  }
}

.pulse {
  animation: pulse;
  animation-duration: 0.8s;
}

.file-upload-area {
  height: 300px;
  width: 550px;
  background-color: white;
}
</style>